<div class="__elements">
  @if (pageState | async; as pageState) {
    @switch (pageState) {
      @case (PageState.WaitingForMeta) {
        <div class="__waiting">
          <strong>{{'waiting-for-response-from-meta' | translate}}</strong>
          <p>{{ "dont-close-this-window" | translate }}</p>
          <div class="__spinner">
            <div class="__spinner-wrapper">
              <app-spinner></app-spinner>
            </div>
          </div>
        </div>
      }
      @case (PageState.WaitingForApi) {
        <div class="__waiting">
          <strong>{{'saving-data' | translate}}</strong>
          <p>{{"one-moment-dont-close-this-window" | translate}}</p>
          <div class="__spinner">
            <div class="__spinner-wrapper">
              <app-spinner></app-spinner>
            </div>
          </div>
        </div>
      }
      @default {
        @if (pageState === PageState.CancelledByUser) {
          <app-display-message
            [type]="MessageType.INFO"
            message="you-have-canceled-the-registration-please-try-again"
          ></app-display-message>
        } @else if (pageState === PageState.Error) {
          <app-display-message
            [type]="MessageType.WARNING"
            message="errors-have-occurred-please-try-again"
          ></app-display-message>
        }

        <app-start-embedded-signup-button
          [onboarding-type]="onboardingType"
        ></app-start-embedded-signup-button>
      }
    }
  }
</div>
